module.exports = __webpack_public_path__ + "static/bible-groups-3210495b1031b2e01de27a235b655b25.jpg";